import { Link } from "react-router-dom";
import logo from "../../assets/images/autoline.jpg";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Profile from "./Header/components/Profile";
import { LoginOutlined } from "@ant-design/icons";
import ImpersonateUser from "../../pages/users/components/Impersonate";
import { ArrowLeftRight } from "lucide-react";
import { Tooltip } from "antd";

export default function AutoHeader() {
  const { token, canImpersonate } = useContext(AuthContext);
  const [isVisible, setVisible] = useState(false);
  const [impersonateModal, setImpersonateModal] = useState(false);


  return (
    <div className="h-14 bg-white flex flex-row justify-between items-center px-5">
      <div className="flex flex-row items-center">
        <Link
          to="/"
          className="flex justify-center items-center border-gray-400 pr-4 bg-white"
        >
          <img src={logo} alt="Logo" height={15} width={160} />
        </Link>
      </div>
      <div className="flex flex-row items-center">
        {token ? (
          <div className="z-50 flex items-center gap-x-2">
            {canImpersonate && (
              <button
                className="border-r border-gray-400 pr-2 mx-2"
                onClick={() => setImpersonateModal(true)}
              >
                <Tooltip title="Impersonate" placement="left">
                  <ArrowLeftRight size={18} color="gray" />
                </Tooltip>
              </button>
            )}
            <Profile isVisible={isVisible} setVisible={setVisible} />
          </div>
        ) : (
          <Link
            to={"/"}
            className="mx-4 flex justify-center items-center text-white rounded-md py-1"
          >
            <LoginOutlined color="#FFFFFF" size={22} />
          </Link>
        )}
      </div>

      {impersonateModal && (
        <ImpersonateUser isVisible={impersonateModal} setVisible={setImpersonateModal} />
      )}
    </div>
  );
}
